export default __webpack_public_path__ + "static/media/image1pro6.2e61e922.jpeg";